import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './AppRouter';
import './index.css';
import { queryClient } from './libs/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
    <Toaster
      position="top-right"
      toastOptions={{
        className: 'text-lg font-medium shadow-2xl rounded-xl',
        success: {
          className: 'bg-teal text-white min-w-[350px] py-4 px-6',
        },
        error: {
          className:
            'border-red-200 bg-red-50 text-red-600 min-w-[350px] py-4 px-6',
        },
      }}
    />
  </React.StrictMode>
);
